import * as React from 'react';
import '../css/stepper.sass';
import Step from './Step';

interface StepperProps {
  format?: string; // default 'number. Other formats 'alpha-lower','alpha-upper' and 'dots' To be added later.
  children: React.ReactNode[];
  customClass?: string;
}

export default function Stepper(props: StepperProps) {
  const { format = 'number' } = props;
  const children = React.Children.toArray(props.children).filter(
    (child: any) => {
      return React.isValidElement(child) && child.type !== React.Fragment;
    }
  );

  let stepStatus:'active' | 'pending' | 'completed' = 'completed';
  let nextStepStatus:'active' | 'pending' | 'completed' = 'completed';
  return (
    <div className={`stepper ${props.customClass ? props.customClass : ''}`}>
      {
        children.map((step: any, index: number) => {
          if(step.props.active){
            stepStatus = 'active';
          } else if(step.props.state){
            stepStatus = step.props.state;
          } else {
            stepStatus = nextStepStatus;
          }
          if(stepStatus==='active'){
            nextStepStatus = 'pending';
          }
        return (
          <>
            {step.props && step.props.label && (
              <Step
                value={format === 'number' ? `${index + 1}` : ''}
                label={step.props.label}
                state={stepStatus}
              />
            )}
          </>
        );
      })}
    </div>
  );
}
